// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section {
  background-color: var(--black-1000);
  color: var(--white-1000);
  padding: 4rem 2.375rem;
  margin: 0 auto;
}
.footer-section .footer-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.footer-section .footer-wrap .footer-grid {
  --footer-grid-number: 4;
  --footer-grid-gap: 4rem;
  display: grid;
  grid-template-columns: repeat(var(--footer-grid-number), 1fr);
  gap: var(--footer-grid-gap);
}
.footer-section .footer-wrap .footer-grid .footer-box .title-text {
  color: var(--white-1000);
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 1.5rem;
}
.footer-section .footer-wrap .footer-grid .footer-box .title-text .horizontal-line {
  width: 100%;
  border: 3px solid var(--quaternaryMain-1000);
  margin-top: 0.313rem;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-link-box {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.75rem;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-link-box .link-item {
  color: var(--white-1000);
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.4;
  text-decoration: none;
  display: inline-block;
  transition: 200ms all ease-in-out;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-link-box .link-item:hover {
  color: var(--primaryMain-1000);
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 2rem;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box .icon-item {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 200ms all ease-in-out;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box .icon-item svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--white-1000);
  transition: 200ms all ease-in-out;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box .icon-item:hover svg {
  fill: var(--primaryMain-1000);
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-img-box {
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  margin-top: 2rem;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-img-box img {
  width: 100%;
  max-width: 7rem;
  height: auto;
  display: block;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-img-box img.rising-img, .footer-section .footer-wrap .footer-grid .footer-box .footer-img-box img.premium-img {
  grid-row-start: 2;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-address-box {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.75rem;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-address-box .address-text {
  color: var(--white-1000);
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.4;
  text-decoration: none;
  display: inline-block;
}
.footer-section .footer-wrap .footer-grid .footer-box .footer-address-box .address-text strong,
.footer-section .footer-wrap .footer-grid .footer-box .footer-address-box .address-text span {
  display: block;
}
.footer-section .footer-wrap .footer-copyright {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
}
.footer-section .footer-wrap .footer-copyright .text {
  color: var(--white-1000);
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}
@media screen and (max-width: 991.98px) {
  .footer-section {
    padding: 2.5rem 1.25rem;
  }
  .footer-section .footer-wrap .footer-grid {
    --footer-grid-number: 3;
    --footer-grid-gap: 2.5rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box:last-child {
    grid-column-start: 1;
    grid-column-end: 4;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .title-text {
    font-size: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .title-text .horizontal-line {
    border: 2px solid var(--quaternaryMain-1000);
    margin-top: 0.25rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-link-box {
    gap: 0.5rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-link-box .link-item {
    font-size: 0.875rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box {
    margin-top: 1rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box .icon-item svg {
    width: 1.125rem;
    height: 1.125rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-img-box {
    margin-top: 1rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-img-box img {
    max-width: 5rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-address-box {
    gap: 0.5rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-address-box .address-text {
    font-size: 0.875rem;
  }
  .footer-section .footer-wrap .footer-copyright {
    margin-top: 2.5rem;
  }
  .footer-section .footer-wrap .footer-copyright .text {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 767.98px) {
  .footer-section {
    padding: 2.5rem 1rem;
  }
  .footer-section .footer-wrap .footer-grid {
    --footer-grid-number: 3;
    --footer-grid-gap: 1.25rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box:last-child {
    grid-column-start: 1;
    grid-column-end: 4;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .title-text {
    font-size: 1.125rem;
    margin-bottom: 1rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-link-box .link-item {
    font-size: 0.75rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box {
    gap: 0.375rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-icon-box .icon-item svg {
    width: 1rem;
    height: 1rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-img-box {
    gap: 0.25rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-img-box img {
    max-width: 3.5rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-address-box .address-text {
    font-size: 0.75rem;
  }
  .footer-section .footer-wrap .footer-copyright {
    margin-top: 2.5rem;
  }
  .footer-section .footer-wrap .footer-copyright .text {
    font-size: 0.75rem;
  }
}
@media screen and (max-width: 639.98px) {
  .footer-section {
    padding: 2.5rem 1rem;
  }
  .footer-section .footer-wrap .footer-grid {
    --footer-grid-number: 2;
    --footer-grid-gap: 1rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box:last-child {
    grid-column-start: 2;
    grid-column-end: 3;
  }
}
@media screen and (max-width: 474.98px) {
  .footer-section {
    padding: 2.5rem 1rem;
  }
  .footer-section .footer-wrap .footer-grid {
    --footer-grid-number: 1;
    --footer-grid-gap: 1rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box:last-child {
    grid-column-start: unset;
    grid-column-end: unset;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-link-box {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  .footer-section .footer-wrap .footer-grid .footer-box .footer-link-box .link-item {
    background-color: var(--primaryMain-300);
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/FooterSectionStyle.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,6DAAA;EACA,2BAAA;AACN;AAEQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAAV;AAEU;EACE,WAAA;EACA,4CAAA;EACA,oBAAA;AAAZ;AAIQ;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAFV;AAIU;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iCAAA;AAFZ;AAIY;EACE,8BAAA;AAFd;AAOQ;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AALV;AAOU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AALZ;AAOY;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AALd;AASc;EACE,6BAAA;AAPhB;AAaQ;EACE,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,WAAA;EACA,gBAAA;AAXV;AAaU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAXZ;AAaY;EAEE,iBAAA;AAZd;AAiBQ;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAfV;AAiBU;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAfZ;AAiBY;;EAEE,cAAA;AAfd;AAsBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AApBN;AAsBM;EACE,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AApBR;AAyBE;EA5IF;IA6II,uBAAA;EAtBF;EAyBI;IACE,uBAAA;IACA,yBAAA;EAvBN;EA0BQ;IACE,oBAAA;IACA,kBAAA;EAxBV;EA2BQ;IACE,kBAAA;IACA,sBAAA;EAzBV;EA2BU;IACE,4CAAA;IACA,mBAAA;EAzBZ;EA6BQ;IACE,WAAA;EA3BV;EA6BU;IACE,mBAAA;EA3BZ;EA+BQ;IACE,gBAAA;EA7BV;EAgCY;IACE,eAAA;IACA,gBAAA;EA9Bd;EAmCQ;IACE,gBAAA;EAjCV;EAmCU;IACE,eAAA;EAjCZ;EAqCQ;IACE,WAAA;EAnCV;EAqCU;IACE,mBAAA;EAnCZ;EAyCI;IACE,kBAAA;EAvCN;EAyCM;IACE,mBAAA;EAvCR;AACF;AA4CE;EAnNF;IAoNI,oBAAA;EAzCF;EA4CI;IACE,uBAAA;IACA,0BAAA;EA1CN;EA6CQ;IACE,oBAAA;IACA,kBAAA;EA3CV;EA8CQ;IACE,mBAAA;IACA,mBAAA;EA5CV;EAgDU;IACE,kBAAA;EA9CZ;EAkDQ;IACE,aAAA;EAhDV;EAmDY;IACE,WAAA;IACA,YAAA;EAjDd;EAsDQ;IACE,YAAA;EApDV;EAsDU;IACE,iBAAA;EApDZ;EAyDU;IACE,kBAAA;EAvDZ;EA6DI;IACE,kBAAA;EA3DN;EA6DM;IACE,kBAAA;EA3DR;AACF;AAgEE;EAjRF;IAkRI,oBAAA;EA7DF;EAgEI;IACE,uBAAA;IACA,uBAAA;EA9DN;EAiEQ;IACE,oBAAA;IACA,kBAAA;EA/DV;AACF;AAqEE;EAnSF;IAoSI,oBAAA;EAlEF;EAqEI;IACE,uBAAA;IACA,uBAAA;EAnEN;EAsEQ;IACE,wBAAA;IACA,sBAAA;EApEV;EAuEQ;IACE,mBAAA;IACA,eAAA;IACA,YAAA;EArEV;EAuEU;IACE,wCAAA;IACA,sBAAA;IACA,uBAAA;EArEZ;AACF","sourcesContent":[".footer-section {\n  background-color: var(--black-1000);\n  color: var(--white-1000);\n  padding: 4rem 2.375rem;\n  margin: 0 auto;\n\n  .footer-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .footer-grid {\n      --footer-grid-number: 4;\n      --footer-grid-gap: 4rem;\n      display: grid;\n      grid-template-columns: repeat(var(--footer-grid-number), 1fr);\n      gap: var(--footer-grid-gap);\n\n      .footer-box {\n        .title-text {\n          color: var(--white-1000);\n          font-size: 1.5rem;\n          font-weight: 600;\n          line-height: 1.4;\n          margin-bottom: 1.5rem;\n\n          .horizontal-line {\n            width: 100%;\n            border: 3px solid var(--quaternaryMain-1000);\n            margin-top: 0.313rem;\n          }\n        }\n\n        .footer-link-box {\n          display: flex;\n          align-items: flex-start;\n          flex-direction: column;\n          gap: 0.75rem;\n\n          .link-item {\n            color: var(--white-1000);\n            font-size: 1rem;\n            font-weight: 300;\n            line-height: 1.4;\n            text-decoration: none;\n            display: inline-block;\n            transition: 200ms all ease-in-out;\n\n            &:hover {\n              color: var(--primaryMain-1000);\n            }\n          }\n        }\n\n        .footer-icon-box {\n          display: flex;\n          flex-wrap: wrap;\n          gap: 0.5rem;\n          margin-top: 2rem;\n\n          .icon-item {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            transition: 200ms all ease-in-out;\n\n            svg {\n              width: 1.25rem;\n              height: 1.25rem;\n              fill: var(--white-1000);\n              transition: 200ms all ease-in-out;\n            }\n\n            &:hover {\n              svg {\n                fill: var(--primaryMain-1000);\n              }\n            }\n          }\n        }\n\n        .footer-img-box {\n          width: fit-content;\n          display: grid;\n          grid-template-columns: repeat(2, 1fr);\n          gap: 0.5rem;\n          margin-top: 2rem;\n\n          img {\n            width: 100%;\n            max-width: 7rem;\n            height: auto;\n            display: block;\n\n            &.rising-img,\n            &.premium-img {\n              grid-row-start: 2;\n            }\n          }\n        }\n\n        .footer-address-box {\n          display: flex;\n          align-items: flex-start;\n          flex-direction: column;\n          gap: 0.75rem;\n\n          .address-text {\n            color: var(--white-1000);\n            font-size: 1rem;\n            font-weight: 300;\n            line-height: 1.4;\n            text-decoration: none;\n            display: inline-block;\n\n            strong,\n            span {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n\n    .footer-copyright {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: 4rem;\n\n      .text {\n        color: var(--white-1000);\n        font-size: 1.125rem;\n        font-weight: 400;\n        line-height: 1.4;\n        text-align: center;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 1.25rem;\n\n    .footer-wrap {  \n      .footer-grid {\n        --footer-grid-number: 3;\n        --footer-grid-gap: 2.5rem;\n  \n        .footer-box {\n          &:last-child {\n            grid-column-start: 1;\n            grid-column-end: 4;\n          }\n\n          .title-text {\n            font-size: 1.25rem;\n            margin-bottom: 1.25rem;\n  \n            .horizontal-line {\n              border: 2px solid var(--quaternaryMain-1000);\n              margin-top: 0.25rem;\n            }\n          }\n  \n          .footer-link-box {\n            gap: 0.5rem;\n  \n            .link-item {\n              font-size: 0.875rem;\n            }\n          }\n  \n          .footer-icon-box {\n            margin-top: 1rem;\n  \n            .icon-item {  \n              svg {\n                width: 1.125rem;\n                height: 1.125rem;\n              }\n            }\n          }\n  \n          .footer-img-box {\n            margin-top: 1rem;\n\n            img {\n              max-width: 5rem;\n            }\n          }\n  \n          .footer-address-box {\n            gap: 0.5rem;\n  \n            .address-text {\n              font-size: 0.875rem;\n            }\n          }\n        }\n      }\n  \n      .footer-copyright {\n        margin-top: 2.5rem;\n  \n        .text {\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2.5rem 1rem;\n\n    .footer-wrap {  \n      .footer-grid {\n        --footer-grid-number: 3;\n        --footer-grid-gap: 1.25rem;\n  \n        .footer-box {\n          &:last-child {\n            grid-column-start: 1;\n            grid-column-end: 4;\n          }\n\n          .title-text {\n            font-size: 1.125rem;\n            margin-bottom: 1rem;\n          }\n  \n          .footer-link-box {\n            .link-item {\n              font-size: 0.75rem;\n            }\n          }\n  \n          .footer-icon-box {\n            gap: 0.375rem;\n\n            .icon-item {  \n              svg {\n                width: 1rem;\n                height: 1rem;\n              }\n            }\n          }\n  \n          .footer-img-box {\n            gap: 0.25rem;\n\n            img {\n              max-width: 3.5rem;\n            }\n          }\n  \n          .footer-address-box {  \n            .address-text {\n              font-size: 0.75rem;\n            }\n          }\n        }\n      }\n  \n      .footer-copyright {\n        margin-top: 2.5rem;\n  \n        .text {\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2.5rem 1rem;\n\n    .footer-wrap {  \n      .footer-grid {\n        --footer-grid-number: 2;\n        --footer-grid-gap: 1rem;\n  \n        .footer-box {\n          &:last-child {\n            grid-column-start: 2;\n            grid-column-end: 3;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 474.98px) {\n    padding: 2.5rem 1rem;\n\n    .footer-wrap {  \n      .footer-grid {\n        --footer-grid-number: 1;\n        --footer-grid-gap: 1rem;\n  \n        .footer-box {\n          &:last-child {\n            grid-column-start: unset;\n            grid-column-end: unset;\n          }\n\n          .footer-link-box {\n            flex-direction: row;\n            flex-wrap: wrap;\n            gap: 0.25rem;\n\n            .link-item {\n              background-color: var(--primaryMain-300);\n              border-radius: 0.25rem;\n              padding: 0.25rem 0.5rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
